import { addEnrolmentQueryParamForAcq129 } from '../../experiments/acq129/acq129Utils';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { getIsActiveAndAssignedToVariantACQ129 } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { getPostAccountCreationSteps } from '../../store/flow/selectors';
import { Step } from '../../views/Step';
export const BranchPricingACQ129 = {
  name: 'BranchPricingACQ129',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariantACQ129(state);
  },
  rebuildFlow: (flow, state, dispatch) => {
    addEnrolmentQueryParamForAcq129();
    const preVerificationSteps = [Step.Pricing, ...getFlowSteps().preVerification];
    const flowSteps = [Step.Pricing, ...flow];
    dispatch(setFlow(flowSteps, preVerificationSteps, getFlowSteps().postVerification, getPostAccountCreationSteps(state), getFlowSteps().postExistingAccountSelection));
    return flowSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};